export const loginSliderOptions = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        centeredSlides: true,
        cssMode: true,
    }
}